import { RateOwnerType } from '@treadinc/horizon-api-spec';
import { noop } from 'lodash-es';
import { createContext, ReactNode, useCallback, useState } from 'react';

interface OwnerContextType {
  selectedOwnerId: string;
  selectedOwnerName: string;
  setSelectedOwner: (id: string, name?: string) => void;
  selectedOwnerType: RateOwnerType;
  setSelectedOwnerType: (type: RateOwnerType) => void;
}

export const OwnerContext = createContext<OwnerContextType>({
  selectedOwnerId: '',
  selectedOwnerName: '',
  setSelectedOwner: noop,
  selectedOwnerType: RateOwnerType.VENDOR,
  setSelectedOwnerType: noop,
});

interface OwnerProviderProps {
  children: ReactNode;
}

export const OwnerProvider = ({ children }: OwnerProviderProps) => {
  const [selectedOwnerId, setSelectedOwnerId] = useState<string>('');
  const [selectedOwnerName, setSelectedOwnerName] = useState<string>('');
  const [selectedOwnerType, setSelectedOwnerType] = useState<RateOwnerType>(
    RateOwnerType.VENDOR,
  );

  const setSelectedOwner = useCallback((id: string, name = '') => {
    setSelectedOwnerId(id);
    setSelectedOwnerName(name);
  }, []);

  return (
    <OwnerContext.Provider
      value={{
        selectedOwnerId,
        selectedOwnerName,
        setSelectedOwner,
        selectedOwnerType,
        setSelectedOwnerType,
      }}
    >
      {children}
    </OwnerContext.Provider>
  );
};
